import { useCallback, useLayoutEffect, useRef } from "react";
function useActions(value, selectableOptions, onChange) {
  const rValues = useRef({ value, selectableOptions });
  useLayoutEffect(() => void (rValues.current = { value, selectableOptions }));
  const handleOnChange = useCallback(
    (_, value2) => {
      onChange?.(value2 || null);
    },
    [onChange]
  );
  return {
    onChange: handleOnChange
  };
}
export {
  useActions
};
//# sourceMappingURL=useActions.js.map
